import {configureStore} from '@reduxjs/toolkit';
import {api} from '~/CreateFabricInvitation/api/api';
import {guestsLegacyActionMapper} from '~/common/fabric/EventGuests/reducers/guests/legacy-reducer';
import {api as guestsApi} from '~/common/fabric/EventGuests/api/api';
import {dataLayerMiddleware} from '~/CreateFabricGreetingCard/middleware/dataLayerMiddleware';
import {previewTransformMiddleware} from '~/CreateFabricGreetingCard/middleware/previewTransform';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {rootReducer} from './reducers';

const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(
    api.middleware,
    guestsApi.middleware,
    dataLayerMiddleware,
    promiseResolverMiddleware,
    previewTransformMiddleware,
    guestsLegacyActionMapper
  );

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {},
  middleware: middlewares,
});
